import { render, staticRenderFns } from "./SnapshotBulkUpload.vue?vue&type=template&id=38a80a70&scoped=true"
import script from "./SnapshotBulkUpload.vue?vue&type=script&lang=js"
export * from "./SnapshotBulkUpload.vue?vue&type=script&lang=js"
import style0 from "./SnapshotBulkUpload.vue?vue&type=style&index=0&id=38a80a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a80a70",
  null
  
)

export default component.exports